import { tradeSalesKeys, useNodeService } from "@fero/hooks";

export const useGetSaleProductsQuery = (productIds: string[]) => {
  const nodeService = useNodeService();
  return nodeService.getSaleProductsByProductId.useQuery(
    tradeSalesKeys.saleProducts(productIds),
    {
      query: {
        productIds: JSON.stringify(productIds),
      },
    },
  );
};
